import clsx from "clsx";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  button: {
    display: "flex",
    width: "100%",
    height: 200,
    borderRadius: 10,
    backgroundColor: "#444",
    backgroundSize: "cover",
    backgroundPosition: "center",
    cursor: "pointer",
    position: "relative",
    marginTop: 5,
  },
  name: {
    color: "white",
    margin: 0,
    position: "absolute",
    right: 10,
    bottom: 5,
    textShadow: "0 0 1px #000000, 0 0 1px #000000, 0 0 1px #000000",
  },
  message: {
    color: "white",
    margin: 0,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  error: {
    border: "2px solid red",
  },
  errorMessageContainer: {
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: "red",
    padding: 5,
    borderRadius: 5,
  },
  errorMessage: {
    color: "white",
  },
});

const AutoplayImageSelector = ({
  image,
  className,
  onClick,
  errorMessage,
}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(classes.button, className, errorMessage && classes.error)}
      style={image ? { backgroundImage: `url("${image?.urls?.low}")` } : {}}
      onClick={onClick}
    >
      {image ? (
        <p className={classes.name}>{image.name}</p>
      ) : (
        <p className={classes.message}>Select an image</p>
      )}
      {!!errorMessage && (
        <div className={classes.errorMessageContainer}>
          <span className={classes.errorMessage}>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default AutoplayImageSelector;
